import awaLogoFooter from 'components/Footer/images/awa-logo.png';
import aweLogoFooter from 'components/Footer/images/awe-logo.png';
import bgHero from 'images/bg-hero.jpg';
import bgHeroLarge from 'images/bg-hero-large.jpg';
import bgGradient from 'images/bg-white.jpg';
import bgWhiteShort from 'images/bg-white-short.jpg';
export const colors = {
  gray: '#f1f1f1',
  red: '#FC2627',
  orange: '#FC5915',
  green: '#00D3A7',
  lightBlue: '#89CBC4',
  primary: '#fffa99',
  primarySecond: '#77EED6',
  secondary: '#00D3A7',
};

export const boothColors = {
  selected: '#1A283E',
  available: '#6F9000',
  other: '#E9FFDD',
  sold: '#FAFAFA',
  sponsor: 'linear-gradient(221.37deg, #FBD468 0%, #FF9C58 100%)',
};

const base = {
  colors,
  boothColors,
};

export const aweTheme = {
  ...base,
  primary: '#f9521d',
  secondary: '#feb317',
  textColor: '#001166',
  navigation: {
    textColor: '#f9521d',
    details: '8–9 July | <b>FBML</b> 10 July | <b>ECML</b> 11 July <span>•</span> Barcelona, Spain',
    borderColor: '#feb317',
  },
  header: {
    titleFont: 'Argon, Lato, Arial',
    textColor: '#001166',
    bgColor: '#FFF7D3',
  },
  button: {
    textColor: '#fff',
    hoveredBg: '#f76c42',
  },
  footer: {
    logo: aweLogoFooter,
    textColor: '#f9521d',
    details: '8–9 July | <b>FBML</b> 10 July | <b>ECML</b> 11 July <span>•</span> Barcelona, Spain',
    borderColor: '#feb317',
    hashtag: '#AWeurope',
  },
  location: {
    venue: 'Fira de Barcelona Montjuïc',
    address: 'Avinguda de la Reina Maria Cristina, s/n, 08004 Barcelona, Spain',
  },
};

export const awaTheme = {
  ...base,
  primary: '#fffa99',
  secondary: '#00D3A7',
  default: '#1A283E',
  disabled: '#444444',
  primarySecond: '#77EED6',
  clay: '#202B36',
  teal: '#95ebd7',
  textColor: '#1A283E',
  cyan: '#00D3A7',
  white: '#fff',
  navigation: {
    textColor: 'rgb(0, 211, 167)',
    details: 'Bangkok, Thailand <span>•</span> 4-5 December 2019',
    mobile: 'Bangkok, Thailand <br /> 4-5 Dec 2019',
    borderColor: 'rgb(0, 211, 167)',
  },
  background: {
    bgHero,
    bgHeroLarge,
    bgGradient,
    bgWhite: bgGradient,
    bgWhiteShort,
  },
  header: {
    titleFont: '"Lato", Helvetica, "Helvetica Neue", Arial, sans-serif',
    textColor: '#fff',
    bgColor: 'rgb(39, 71, 114)',
    bgImage: bgHero,
  },
  button: {
    textColor: '#000',
    hoveredBg: 'rgb(252, 241, 93)',
  },
  footer: {
    logo: awaLogoFooter,
    textColor: 'rgb(0, 211, 167)',
    default: '#1A283E',
    details: 'Bangkok, Thailand <span>•</span> 4-5 December 2019',
    borderColor: 'rgb(0, 211, 167)',
    hashtag: '#SWC',
  },
  location: {
    venue: 'Centara Grand and Bangkok Convention Centre',
    address: 'Level 22, 999/9 Rama 1 Road, Pathumwan, Bangkok 10330 Thailand',
  },
};

export const position = {
  centerX: 'left: 50%; transform: translate(-50%, 0);',
  centerY: 'top: 50%; transform: translate(0, -50%);',
  centerXY: 'top: 50%; left: 50%; transform: translate(-50%, -50%);',
  centerRemove: 'left: auto; top: auto; transform: translate(0, 0);',
};



// WEBPACK FOOTER //
// ./src/themes/variables.js